import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

import { WEEKLY_SCHEDULE_DAYS } from '../constants';
import {
  WEEKLY_SCHEDULE_CORNER_CELL_SX,
  WEEKLY_SCHEDULE_GRID_SX,
  WEEKLY_SCHEDULE_HEADER_CELL_SX,
} from '../styles';

export default function ScheduleGridHeader() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={WEEKLY_SCHEDULE_GRID_SX}>
      <Box sx={WEEKLY_SCHEDULE_CORNER_CELL_SX} />
      {WEEKLY_SCHEDULE_DAYS.map((day) => (
        <Typography key={day.key} component="div" sx={WEEKLY_SCHEDULE_HEADER_CELL_SX}>
          {isMobile ? day.shortLabel : day.label}
        </Typography>
      ))}
    </Box>
  );
}
